<template>

    <trax-ui-ajax-table-with-crud-actions 
        :id="id" :titles="titles" :props="props" :bus="bus" :actions="actions"
        :endpoint="endpoint" :endpoint-params="endpointParams"
        order-column="3" order-dir="desc">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: {
            bus: null,
            id: null,
            endpoint: null
        },

        data: function() {
            return {
                titles: [
                    lang.polaris.training.program,
                    lang.polaris.account.group,
                    lang.polaris.form.status,
                    lang.polaris.training.starting,
                    lang.polaris.training.ending,
                    ''
                ],
                props: [
                    {source: 'program.name', orderable: true },
                    {source: 'cohort.name', orderable: true },
                    {source: this.status },
                    {source: this.startDate, order: 'start_date' },
                    {source: this.endDate, order: 'end_date' }
                ],
                endpointParams: {
                    relations: ['program', 'cohort']
                },
                status_select: data.status_select,
                actions: [
                    {name: 'dashboard', icon: 'dashboard', class: 'btn-default', event: 'dashboard'}
                ]
            }
        },

        created: function() {
            this.bus.$on(this.id+'-dashboard', this.openDashboard);
        },
        
        methods: {
        
            // Actions

            openDashboard(registration) {
                var routes = window.data.program_dashboard_routes;
                var href = routes[registration.program.type]+'/registration/'+registration.id;
                window.location = href;
            },

            // Columns rendering

            status(data, type, row, meta) {
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (row.status == 'active') color = 'success';
                else if (row.status == 'maintenance') color = 'warning';
                else if (row.status == 'archived') color = 'default';
                return '<span class="badge badge-'+color+'">'+label+'</span>';
            },

            startDate(data, type, row, meta) {
                if (!row.start_date) return '';
                if (moment(row.start_date, 'YYYY-MM-DD', true).isValid()) {
                    return moment(row.start_date).format('DD MMM YYYY');
                }
                return row.start_date;
            },

            endDate(data, type, row, meta) {
                if (!row.end_date) return '';
                if (moment(row.end_date, 'YYYY-MM-DD', true).isValid()) {
                    return moment(row.end_date).format('DD MMM YYYY');
                }
                return row.end_date;
            }

        }

    }
</script>
